
import React from "react";
import ServiceCard from "@/components/ServiceCard";
import { Lightbulb, Heart, Compass, Brain, GraduationCap, Users } from "lucide-react";

const ServicesSection = () => {
  return (
    <section className="section-spacing bg-joerg-50" id="services">
      <div className="container px-4 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block text-primary font-medium mb-4 px-3 py-1 bg-primary/10 rounded-full text-sm">
            Mein Angebot
          </span>
          <h2 className="text-center">Finanzcoaching mit Herz und Verstand</h2>
          <p className="mt-4 text-joerg-600 text-left">
            Mein Coaching-Angebot umfasst verschiedene Schwerpunkte und Formate, die alle ein gemeinsames Ziel haben: dir zu helfen, deine finanzielle Zukunft selbstbestimmt zu gestalten – ob als Privatperson, Entscheider oder High-Performer, der seine privaten Finanzen genauso professionell ordnen will wie sein Business.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <ServiceCard
            title="Klarheit im Finanzdschungel"
            description="Gemeinsam schaffen wir Übersicht in deinen finanziellen Angelegenheiten und entwickeln eine Struktur, die zu deinem Leben passt – unabhängig davon, wie komplex deine Situation ist."
            icon={<Lightbulb className="h-6 w-6" />}
            delay={0}
            hideLink={true}
          />
          <ServiceCard
            title="Emotionaler Bezug zu Geld"
            description="Wir erforschen, wie deine Beziehung zu Geld entstanden ist und wie sie deine Entscheidungen beeinflusst. Durch diese Bewusstwerdung kannst du selbstbestimmter mit deinen Finanzen umgehen."
            icon={<Heart className="h-6 w-6" />}
            delay={150}
            hideLink={true}
          />
          <ServiceCard
            title="Finanzieller Kompass"
            description="Was ist dir wirklich wichtig? Wir richten deine finanziellen Entscheidungen an deinen persönlichen Werten aus und entwickeln einen individuellen Kompass für deine Finanzplanung."
            icon={<Compass className="h-6 w-6" />}
            delay={300}
            hideLink={true}
          />
          <ServiceCard
            title="Behavioral Finance"
            description="Verstehe, wie psychologische Faktoren – die sogenannte Finanzpsychologie – deine finanziellen Entscheidungen beeinflussen und lerne, typische Denkfallen zu erkennen und zu umgehen."
            icon={<Brain className="h-6 w-6" />}
            delay={450}
            hideLink={true}
          />
          <ServiceCard
            title="Finanzielle Bildung"
            description="Komplexe Finanzthemen verständlich erklärt – ohne Fachchinesisch und Verkaufsabsichten. Du erhältst das Wissen, um informierte Entscheidungen selbst treffen zu können."
            icon={<GraduationCap className="h-6 w-6" />}
            delay={600}
            hideLink={true}
          />
          <ServiceCard
            title="Familien-Finanzmediation"
            description="Konflikte um Geld in Partnerschaften oder Familien konstruktiv lösen. Wir schaffen einen sicheren Raum, um über dieses oft tabuisierte Thema zu sprechen."
            icon={<Users className="h-6 w-6" />}
            delay={750}
            hideLink={true}
          />
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
